define('models/PaymentModeCollection',['underscore','ObjectCollection','LocalStorage','models/PaymentModeModel'],function (_,ObjectCollection,LocalStorage,PaymentModeModel) {
    //
    // Collection PaymentMode
    //
    var PaymentModeCollectionPrototype = {
        
        name:'PaymentModeCollection',
        route:'apiPaymentModeCollection',
        model:PaymentModeModel,
        initialize:function(){
            // ObjectCollection constructor heritage
            var collection = this;
            ObjectCollection.prototype.initialize.apply(this,arguments);
            //
        },
        getPaymentMode:function(id_payment_mode){
            var paymentMode = null;
            this.findWhere(function(paymentGroup){
               paymentMode = paymentGroup.getPaymentMode(id_payment_mode);
               return !!paymentMode;
            });
            return !!paymentMode ? paymentMode: null;
        }
    };

    var PaymentModeCollection = ObjectCollection.extend(LocalStorage).extend(PaymentModeCollectionPrototype);

    return PaymentModeCollection;
});
